// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/1.4.0/js/" + chunkId + "." + {"vendors-node_modules_dayjs_plugin_customParseFormat_js-node_modules_dayjs_plugin_duration_js--74cc8a":"02ecb26b","pages-FavoriteList":"fcd4f50f"}[chunkId] + ".chunk.js";
};